import { render, staticRenderFns } from "./VerificationSMSStatusModal.vue?vue&type=template&id=db637e4e&scoped=true&"
import script from "./VerificationSMSStatusModal.vue?vue&type=script&lang=js&"
export * from "./VerificationSMSStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db637e4e",
  null
  
)

export default component.exports